import React, { useState } from "react";
import image from "../../../assets/images/thankyouImg.svg";
import CustomModal from "../../../components/WebsiteComponents/CustomModal";
import TicketReceipt from "../MyTickets/TicketReceipt";
import { fileUrl, URL } from "../../../utils/Constants";

const Finished = (props) => {
  const [receiptModal, setReceiptModal] = useState(false);
  const [receiptPdf, setReceiptPdf] = useState("");

  const toggleModal = () => {
    setReceiptModal(!receiptModal);
  };

  const handleViewReceipt = () => {
    setReceiptPdf(props.bookingDetailsPdf);

    setReceiptModal(true);
  };

  return (
    <>
      <div
        className="container justify-content-center text-center w-75"
        style={{ minheight: "40vh" }}
      >
        <div className="row mt-4">
          <div className="col">
            <div className="d-flex align-items-center justify-content-center">
              <div>
                <img
                  className="center-block p-4"
                  style={{ width: "60%" }}
                  src={image}
                  alt="No preview"
                />
              </div>
            </div>

            <h4>Thank you for choosing us...</h4>
            <p>
              {" "}
             Your booking has been confirmed. Please contact us at 01-5151555 for any queries or suggestions.
            </p>
          </div>
        </div>
        <div className="d-flex flex-column align-items-center mb-5">
          <button className="btn btn-lg text-white w-50 mb-2" onClick={handleViewReceipt} style={{ backgroundColor: '#6c63ff' }}>
            View receipt
          </button>
          <a href={`${URL.downloadTicket}/${props.bookingDetailsPdf.id}/${props.bookingDetailsPdf.file_name}`} className="btn btn-lg w-50 " style={{ border: "1px solid #6c63ff"}} target="_blank">
            Download
          </a>
        </div>
      </div>

      <CustomModal
        modal={receiptModal}
        modalHeader={"Receipt"}
        modalBody={<TicketReceipt receiptPdf={receiptPdf} />}
        size="lg"
        toggleModal={toggleModal}
      ></CustomModal>
    </>
  );
};

export default Finished;
